module.exports = __webpack_public_path__ + "static/1-ccc698f384d9d1248aead477ef3ad82c.jpg";